import { useGetEarningsQuery } from '../../../../app/Slices/SevenDayApiSlice';
import { NavigateNext, WalletOutlined } from '@mui/icons-material';
import {
    Box,
    Card,
    CardContent,
    Avatar,
    Typography,
    useTheme,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import SkeletonLayout from './SkeletonLayout';

const IncomeCard = () => {
    const navigate = useNavigate();

    const { data: earnings } = useGetEarningsQuery({
        year: new Date().getFullYear(),
    });

    const revenue = earnings?.bills[earnings?.bills.length - 1].amount ?? 0;
    const theme = useTheme();

    return (
        <Card
            sx={{
                cursor: 'pointer',
            }}
            onClick={() => navigate('/earnings')}
        >
            <CardContent sx={{ m: 1 }}>
                {earnings ? (
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 1,
                            }}
                        >
                            <Avatar
                                variant='rounded'
                                sx={{
                                    height: 25,
                                    width: 25,
                                    bgcolor: theme.palette.neutral.main,
                                    color: 'text.primary',
                                }}
                            >
                                <WalletOutlined fontSize='small' />
                            </Avatar>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                Revenue
                            </Typography>
                            <NavigateNext />
                        </Box>
                        <Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '3rem',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    ${(revenue / 1000).toFixed(0)}k
                                </Typography>
                            </Box>
                        </Box>
                        <Typography variant='overline' sx={{ lineHeight: 0 }}>
                            Month-to-date
                        </Typography>
                    </>
                ) : (
                    <SkeletonLayout extended />
                )}
            </CardContent>
        </Card>
    );
};

export default IncomeCard;
